export default __webpack_public_path__ + "static/media/accountdashboard.e52895eb.jpg";